import $ from 'jquery';
import { mapActions, mapGetters } from 'vuex';
import { dashboardModules } from '@/api';
import { SITE_URL } from '@/api/config';
import { FETCH_GLOBAL_OUTLOOK, ADDTAB } from '@/store/actions.type';
// this.$store.state.appsetting.theme
export default {
  name: 'worldmap',
  created() {
    this.fetchglobaloutlook()
  },
  data: function () {
    return {
      globaloutlookLoading: true,
      mapdata: this.$store.state.dashboard,
      choice: 'btnWorldMap',
      classObjectMap: 'btnWorldMap',
      classObjectBars: '',
      auth: this.$store.state.auth.isAuthenticated,
      acount:0,
      ccount:0,
      rcount:0,
      ucount:0,
    }
  },
  methods: {


    computetrend123() {
      let aclass = '.idof-d-A';
      let cclass = '.idof-d-C';
      let rclass = '.idof-d-R';
      let uclass = '.idof-d-U';
      let acount_data = $(aclass).attr("id");
      let ccount_data = $(cclass).attr("id");
      let rcount_data = $(rclass).attr("id");
      let ucount_data = $(uclass).attr("id");
      if(acount_data){
        this.acount=acount_data;
      }
      if(ccount_data){
        this.ccount=ccount_data;
      }
      if(rcount_data){
        this.rcount=rcount_data;
      }
      if(ucount_data){
        this.ucount=ucount_data;
      }
    },
    ...mapActions( {
      fetchglobaloutlookData: FETCH_GLOBAL_OUTLOOK,
      createRvTab: ADDTAB
    } ),
    async fetchglobaloutlook() {
      this.globaloutlookLoading = false
      await this.fetchglobaloutlookData()
      this.globaloutlookLoading = true
      $( '.footerMenu' ).addClass( 'footerhide' )
      //$( '.footerMenu' ).css("display",'none');
    },
    async createTab( categoryName, type, post ) {
      $( '.footerMenu' ).addClass( 'footerhide' )
      $( '.footerMenu' ).css( 'display', 'none' )
      var tabobj = {}
      tabobj['type'] = type
      tabobj['categoryName'] = categoryName
      tabobj['post'] = post
      this.createRvTab( tabobj )
      // events.selectCurrentAcative(currentTab)
    },
    makeActive: function ( val ) {
      this.choice = val
      if ( val == 'btnWorldMap' ) {
        this.classObjectMap = val
      } else {
        this.classObjectMap = '';
      }

      if ( val == 'btnWorldBars' ) {
        this.classObjectBars = val
      } else {
        this.classObjectBars = '';
      }
    },
    isActiveTab: function ( val ) {
      return this.choice === val
    },
    worldmapstyle() {
      var mapstyledata = '';
      var style = this.$store.state.dashboard.outlook.data.map.style
      $.each( style, function ( key, value ) {
        $( '#worldmaptrendstyle' ).append( value )
      } )
      
      // return this.dashboardstate()
    }
  },
  computed: {
   
    outlookData() {
      setInterval(() => {
        this.computetrend123()
      }, 1000)
      let aclass = '.idof-d-A';
      let cclass = '.idof-d-C';
      let rclass = '.idof-d-R';
      let uclass = '.idof-d-U';
      let acount_data = $(aclass).attr("id");
      let ccount_data = $(cclass).attr("id");
      let rcount_data = $(rclass).attr("id");
      let ucount_data = $(uclass).attr("id");
      if(acount_data){
        this.acount=acount_data;
      }
      if(ccount_data){
        this.ccount=ccount_data;
      }
      if(rcount_data){
        this.rcount=rcount_data;
      }
      if(ucount_data){
        this.ucount=ucount_data;
      }
      return this.$store.state.dashboard.outlook.data
      this.worldmapstyle()
      // this.styleset("path[title='China']{ fill: #fecee6 !important; } ")
    }
  },

  ...mapGetters( ['dashboardstate'] ),

  mounted: function () {
    // alert(this.$store.state.appsetting.theme);
    var format = d3.format( ',' )
    var windowSize = $( window ).width()
    //alert(windowSize);
    if ( windowSize < 1400 ) {
      if ( windowSize < 1130 ) {
        // ipad
        var mapWidth = 500
        var mapHeight = 300
        var scale = 70
      } else {
        // ipad pro
        var mapWidth = 650
        var mapHeight = 300
        var scale = 70
      }
    } else {
      var mapWidth = 900
      var mapHeight = 300
      var scale = 80
    }

    var margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      width = mapWidth - margin.left - margin.right,
      height = mapHeight - margin.top - margin.bottom

    var color = d3
      .scaleThreshold()
      .domain( [
        10000,
        100000,
        500000,
        1000000,
        5000000,
        10000000,
        50000000,
        100000000,
        500000000,
        1500000000
      ] )
      .range( [
        'rgb(247,251,255)',
        'rgb(222,235,247)',
        'rgb(198,219,239)',
        'rgb(158,202,225)',
        'rgb(107,174,214)',
        'rgb(66,146,198)',
        'rgb(33,113,181)',
        'rgb(8,81,156)',
        'rgb(8,48,107)',
        'rgb(3,19,43)'
      ] )

    var path = d3.geoPath()

    var svg = d3
      .select( '#worldmap' )
      .append( 'svg' )
      .attr( 'width', width )
      .attr( 'height', height )
      .append( 'g' )
      .attr( 'class', 'map' )
    //alert(scale);
    var projection = d3
      .geoMercator()
      .scale( scale )
      .translate( [width / 2.5, height / 1.5] )

    var path = d3.geoPath().projection( projection )
    //console.log( 'path', path )

    queue()
      .defer(
        d3.json,
        SITE_URL +
          'wp-content/plugins/won-global-outlook-map/includes/data/world_countries.json'
      )
      .defer(
        d3.csv,
        SITE_URL +
          'wp-content/plugins/won-global-outlook-map/includes/data/country-capitals.csv'
      )
      .await( ready )

    function ready( error, data, population ) {
      svg
        .append( 'g' )
        .attr( 'class', 'countries' )
        .selectAll( 'path' )
        .data( data.features )
        .enter()
        .append( 'path' )
        .attr( 'd', path )
        .attr( 'id', function ( d, i ) {
          return d.id
        } )
        .attr( 'title', function ( d, i ) {
          return d.properties.name.toLowerCase()
        } )
        .style( 'color', '#fff' )
        .style( 'fill', '#cfcfd3' )
        .style( 'opacity', 0.8 )
        // tooltips
        .style( 'stroke', 'white' )
        .style( 'stroke-width', 0.3 )
      d3.csv(
        SITE_URL +
          'wp-content/plugins/won-global-outlook-map/includes/data/country-capitals.csv',
        function ( err, capitals ) {
          capitals.forEach( function ( i ) {
            addpoint( i.CapitalLongitude, i.CapitalLatitude, i.CapitalName )
          } )
        }
      )
    }
    var theme = this.$store.state.appsetting.theme
    function addpoint( lat, lon, text ) {
      var gpoint = svg
        .append( 'g' )
        .attr( 'class', 'gpoint' )
        .style( 'fill', '#000' )
      if ( theme == 'd' ) {
        var gpoint = svg
          .append( 'g' )
          .attr( 'class', 'gpoint' )
          .style( 'fill', '#fff' )
      }
      /*
        Doing country text white for the black theme
       */

      var x = projection( [lat, lon] )[0]
      var y = projection( [lat, lon] )[1]

      // conditional in case a point has no associated text
      if ( text.length > 0 ) {
        gpoint
          .append( 'text' )
          .attr( 'x', x + 2 )
          .attr( 'y', y + 2 )
          .attr( 'class', 'text' )
          .text( text )
      }
    }

    let style = document.createElement( 'style' )
    style.type = 'text/css';
    style.id = 'worldmaptrendstyle';
    style.appendChild( document.createTextNode( '' ) )
    this.styleNode = style.childNodes[0] // a reference I store in the data hash
    // this.styleNode.textContent = data
    document.head.appendChild( style )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/worldmap.js